import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils';

type TypeCheckValidPassTokenResponse = {
  code: string;
  message: string;
};

/**
 * @description 비밀번호 확인 토큰 유효성 검사 api
 */
export const useCheckValidPassToken = () => {
  const queryClient = useQueryClient();

  const requestGetCenterCodes = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (res: TypeCheckValidPassTokenResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    const endPoint = '/labor-account/validate-pass-token';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeCheckValidPassTokenResponse>>({
      queryKey: ['labor-account', 'validate-pass-token'],
      queryFn: () => axiosInstance.get(endPoint, { headers: { checkPassToken: true } }),
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError);
  };

  return requestGetCenterCodes;
};
